import { threeColors } from "../theme/tokens";

export function Lights({ climax = false }) {
  return (
    <>
      <ambientLight intensity={climax ? 0.35 : 0.22} color={threeColors.paper} />
      <hemisphereLight
        intensity={0.35}
        color={threeColors.paper}
        groundColor={threeColors.ink}
      />
      <directionalLight
        castShadow
        position={[5, 9, 4]}
        intensity={climax ? 2.8 : 2.1}
        color={climax ? threeColors.signal : threeColors.paper}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={24}
        shadow-camera-top={6}
        shadow-camera-right={6}
        shadow-camera-bottom={-6}
        shadow-camera-left={-6}
      />
      <directionalLight
        position={[-6, 3, -5]}
        intensity={0.7}
        color={threeColors.gray}
      />
      <spotLight
        position={[0, 7, 3]}
        angle={0.38}
        penumbra={0.65}
        intensity={climax ? 3.2 : 2.0}
        color={climax ? threeColors.signal : "#fff8ea"}
        castShadow={false}
      />
      <pointLight
        position={[0, -1.2, 2.5]}
        intensity={0.55}
        color={threeColors.metal}
        distance={12}
      />
    </>
  );
}
